import React from "react";
import { LogOut } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "components/ui/avatar";
import { Button } from "components/ui/button";
import { Card, CardContent } from "components/ui/card";
import { Separator } from "components/ui/separator";

interface User {
  first_name: string;
  last_name: string;
  email: string;
  picture_url: string;
}

interface ProfileModalProps {
  logout: (isManual?: boolean) => void;
  currentUser: User;
  onClose: () => void;
}

function ProfileModal({ logout, currentUser, onClose }: ProfileModalProps) {
  return (
    <>
      {/* Overlay for click outside */}
      <div
        className="fixed inset-0 z-[9998] bg-transparent"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed top-16 right-4 z-[9999] w-96">
        <Card className="bg-gray-50 shadow-xl border border-gray-200/50">
          <CardContent className="p-0">
            {/* User Info Section */}
            <div className="bg-white rounded-t-lg p-4">
              <div className="flex items-center space-x-3">
                <Avatar className="h-16 w-16">
                  <AvatarImage
                    src={currentUser.picture_url}
                    alt={`${currentUser.first_name}'s avatar`}
                  />
                  <AvatarFallback className="text-lg font-semibold bg-brand text-white">
                    {currentUser.first_name.charAt(0).toUpperCase()}
                    {currentUser.last_name.charAt(0).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {currentUser.first_name} {currentUser.last_name}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {currentUser.email}
                  </p>
                </div>
              </div>
            </div>

            <Separator />

            {/* Signout Section */}
            <div className="p-2">
              <Button
                variant="ghost"
                className="w-full justify-start text-gray-700 hover:text-gray-900 hover:bg-blue-50 transition-colors"
                onClick={() => logout(true)}
              >
                <LogOut className="h-4 w-4 mr-3" />
                Sign out
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}

export default ProfileModal;
